import { useAsyncPaginatedData } from "../../../../hooks/useAsyncPaginatedData";
import { listRejectedDocuments } from "../../../../lib/corpusApi";

/** Paginated fetch of gate-rejected URLs, newest first. */
export function useRejectedDocuments() {
  const { items, loading, error, pagination } = useAsyncPaginatedData(
    (offsetPage) => listRejectedDocuments(offsetPage),
    { pageSize: 25, key: "rejected" }
  );

  return { items, loading, error, pagination };
}
